import { useFormikContext } from "formik";
import { Block, Button } from "@/components";
import { spacings } from "@/assets/themes";
import polyglot from "@/utils/polyglot";
import PaymentMethodsUpdated from "../common/payment-methods";
import { getPricing } from "./utils";
import { getPaymentSummaryItems } from "../common/payment-methods/utils/get-payment-summary-items";

const JobberBookingPassSubmitButton = ({ isLoading, data, onSubmit }) => {
  const formikUtils = useFormikContext();
  return (
    <Block
      position="sticky"
      bottom={spacings.m}
      paddingX={spacings.m}
      paddingBottom={spacings.m}
    >
      <PaymentMethodsUpdated.PayButtonEnhancer
        block
        textType="book"
        disabled={!formikUtils.isValid}
        amount={getPricing(formikUtils.values, { ...data })?.total}
        lineItems={getPaymentSummaryItems({
          ...getPricing(formikUtils.values, { ...data }),
          voucher_code: formikUtils.values.voucher_code,
        })}
        isLoading={isLoading}
        onPaymentAuthorized={({ token, applePaySession }) =>
          onSubmit(
            {
              ...formikUtils.values,
              token,
              applePaySession,
            },
            formikUtils
          )
        }
      >
        <Button.Large
          block
          type="submit"
          disabled={!formikUtils.isValid}
          isLoading={isLoading}
        >
          {polyglot.t("common.booking")}
        </Button.Large>
      </PaymentMethodsUpdated.PayButtonEnhancer>
    </Block>
  );
};
export default JobberBookingPassSubmitButton;
